export const CookieConsentStatus = {
  PENDING: 'pending',
  GRANTED: 'granted',
  DENIED: 'denied'
} as const;

export type CookieConsentStatus = (typeof CookieConsentStatus)[keyof typeof CookieConsentStatus];

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: any[];
  }
}

/**
 * Analytics event types for Google Tag Manager tracking
 * @enum {string}
 * @readonly
 * @description Each event has a corresponding custom event set up in Google Tag Manager
 *
 * @property {string} PAGE_VIEW - Tracks page navigation events (value: 'track_page_view')
 * @property {string} FORM_SUBMIT - Tracks form submission events (value: 'track_form_submit')
 * @property {string} SESSION_START - Tracks session initialization events (value: 'track_session_start')
 */
export enum EVENT_TYPE {
  PAGE_VIEW = 'track_page_view',
  FORM_SUBMIT = 'track_form_submit',
  SESSION_START = 'track_session_start'
}

/**
 * Push an event to Google Tag Manager
 * @param event - The event to push
 * @param dataVariables - The data variables to push, e.g. { accountId: '123', gaId: '456' }
 */
export default function pushEvent(
  event: EVENT_TYPE,
  dataVariables: Record<string, string | number | boolean>,
  hasConsent: CookieConsentStatus
) {
  if (
    typeof window !== 'undefined' &&
    window.dataLayer &&
    hasConsent !== CookieConsentStatus.PENDING
  ) {
    window.dataLayer.push({ event, ...dataVariables });
  }
}

export function updateGAConsent(consent: CookieConsentStatus) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push([
      'consent',
      'update',
      {
        analytics_storage:
          consent === CookieConsentStatus.DENIED
            ? CookieConsentStatus.DENIED
            : CookieConsentStatus.GRANTED
      }
    ]);
  }
}
